import {
    LOGIN_FAIL,
    LOGIN_SUCCESS,
    LOGIN,
    LOGOUT,
    REGISTER,
    REGISTER_SUCCESS,
    REGISTER_FAIL,
    VERIFY,
    VERIFY_SUCCESS,
    VERIFY_FAIL,
    FORGOTPASSWORD,
    FORGOTPASSWORD_SUCCESS,
    FORGOTPASSWORD_FAIL,
    RESET,
    RESET_SUCCESS,
    RESET_FAIL,
    CLEAR_REQUEST,
    GET_LOCATION,
    REFRESH_TOKEN,
    REFRESH_TOKEN_SUCCESS,
    REFRESH_TOKEN_FAIL,
    CREATE_CART_SUCCESS,
    GET_LOCATION_DETAILS,
} from '../actionTypes';

const initialState = {
    loading: false,
};

export const authReducer = (state = initialState, action) => {
    switch (action.type) {
        case LOGIN:
            return { ...state, loading: true };
        case LOGIN_SUCCESS:
            return { ...state, loading: false, user: action.payload, userData: action.userData };
        case LOGIN_FAIL:
            return { ...state, loading: false, error: action.payload };
        case CLEAR_REQUEST:
            return {};
        case LOGOUT:
            return {};
        default:
            return state;
    }
};

export const regReducer = (state = initialState, action) => {
    switch (action.type) {
        case REGISTER:
            return { ...state, loading: true };
        case REGISTER_SUCCESS:
            return { ...state, loading: false, user: action.payload, userData: action.userData };
        case REGISTER_FAIL:
            return { ...state, loading: false, error: action.payload };
        case CLEAR_REQUEST:
            return {};
        case LOGOUT:
            return {};
        default:
            return state;
    }
};

export const forgotPasswordReducer = (state = initialState, action) => {
    switch (action.type) {
        case FORGOTPASSWORD:
            return { ...state, loading: true };
        case FORGOTPASSWORD_SUCCESS:
            return { ...state, loading: false, user: action.payload };
        case FORGOTPASSWORD_FAIL:
            return { ...state, loading: false, error: action.payload };
        case LOGOUT:
            return {};
        default:
            return state;
    }
};

export const verifyReducer = (state = initialState, action) => {
    switch (action.type) {
        case VERIFY:
            return { ...state, loading: true };
        case VERIFY_SUCCESS:
            return {
                ...state,
                loading: false,
                verifiedUser: action.payload,
                details: action.userDetails,
            };
        case VERIFY_FAIL:
            return { ...state, loading: false, error: action.error };
        case CREATE_CART_SUCCESS:
            return { ...state, loading: false, quoteId: action.payload };
        case CLEAR_REQUEST:
            return { ...state, loading: false };
        case LOGOUT:
            return {};
        default:
            return state;
    }
};

export const resetReducer = (state = initialState, action) => {
    switch (action.type) {
        case RESET:
            return { ...state, loading: true };
        case RESET_SUCCESS:
            return { ...state, loading: false, resetUser: action.payload };
        case RESET_FAIL:
            return { ...state, loading: false, error: action.payload };
        case LOGOUT:
            return {};
        default:
            return state;
    }
};

export const userLocationReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_LOCATION:
            return {
                ...state,
                country: action.payload,
            };
        case GET_LOCATION_DETAILS:
            return {
                ...state,
                location: action.payload,
            };
        default:
            return state;
    }
};

export const refreshTokenReducer = (state = initialState, action) => {
    switch (action.type) {
        case REFRESH_TOKEN:
            return { ...state, loading: true };
        case REFRESH_TOKEN_SUCCESS:
            return { ...state, token: action.payload };
        case REFRESH_TOKEN_FAIL:
            return { ...state, loading: false, error: action.payload };
        default:
            return state;
    }
};
